import React from "react";
import {
  Filter,
  TextInput,
  BooleanInput,
  Button,
  Link,
  ReferenceInput,
  SelectInput,
  Create,
  List,
  DateInput,
  NumberInput,
  Datagrid,
  TextField,
  Pagination,
  DisabledInput,
  DateField,
  Edit,
  SimpleForm,
  EditButton
} from "react-admin";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import ItemSwitch from "../components/itemSwitch";
import { CustomBaseFilter } from "../components/selectboxfilter/customBaseFilter";
import moment from "moment";
const GlovePagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const HistoryButton = props => (
  <Button
    component={Link}
    to={{
      pathname: `/item_history/gloves/${props.record.id}`
    }}
    label="Device History"
  >
    <ChatBubbleIcon />
  </Button>
);

const GloveFielter = props => (
  <Filter {...props}>
    <CustomBaseFilter label="Base Location" source="location_id" alwaysOn />
  </Filter>
);

const SwitchButton = props => {
  const rentals = props.record.number_rentals || 0;
  if (rentals > 0 && props.record.status === 1) {
    return (
      <ItemSwitch
        item={props.record}
        type={props.resource}
        history={props.history}
        location={props.location}
      />
    );
  }
  return <React.Fragment />;
};

export const GloveList = props => (
  <List
    {...props}
    resource="gloves"
    pagination={<GlovePagination />}
    filters={<GloveFielter />}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField label="Glove ID" source="id" sortable={false} />
      <TextField
        label="Last Location"
        source="location_name"
        sortable={false}
      />
      <TextField label="Glove Model" source="model" sortable={false} />
      <DateField
        label="Purchase Date"
        source="purchase_date"
        sortable={false}
      />
      <EditButton />
      <HistoryButton />
      <SwitchButton {...props} />
    </Datagrid>
  </List>
);

const GloveTitle = object => (
  <span>
    {" Edit Glove Device"} &quot;{object.record.model}&quot;
  </span>
);

const GloveCreateTitle = record => <span>Create Glove Device</span>;

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const GloveCreate = props => (
  <Create title={<GloveCreateTitle />} {...props}>
    <SimpleForm>
      <TextInput label="Model" source="model" />
      <DateInput label="Purchase Date" source="purchase_date"  locales="es-Es" options={{ timeZone: 'UTC' }} />
      <NumberInput source="purchase_price" label="Purchase Price" />
      <BooleanInput label="Status" source="status" />
      <ReferenceInput
        label="Primary Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export const GloveEdit = props => (
  <Edit title={<GloveTitle />} {...props}>
    <SimpleForm>
      <DisabledInput label="Id" source="id" />
      <TextInput label="Model" source="model" />
      <DateInput label="Purchase Date" source="purchase_date"  locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
      <NumberInput source="purchase_price" label="Purchase Price" />
      <BooleanInput label="Status" source="status" />
      <ReferenceInput
        label="Primary Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/resources/gloves.js